import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import BoxedTitle from "@/components/BoxedTitle";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Portfolio from "@/pages/Portfolio";
import Services from "@/pages/Services";
import History from "@/pages/History";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import AdminHome from "@/pages/AdminHome";
import AdminInbox from "@/pages/AdminInbox";
import Market from "@/pages/admin/market/Market";
import Competitors from "@/pages/admin/market/Competitors";
import CompetitorDetail from "@/pages/admin/market/CompetitorDetail";
import YCApplication from "@/pages/admin/YCApplication";
import AdminEssays from "@/pages/admin/essays/AdminEssays";
import AdminEssayEdit from "@/pages/admin/essays/AdminEssayEdit";
import AdminReferences from "@/pages/admin/references/AdminReferences";
import AdminReferenceEdit from "@/pages/admin/references/AdminReferenceEdit";
import AdminIdeas from "@/pages/admin/ideas/AdminIdeas";
import AdminIdeaEdit from "@/pages/admin/ideas/AdminIdeaEdit";
import IdeaCapture from "@/pages/admin/ideas/IdeaCapture";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

/**
 * Renders the site Navbar + Footer everywhere except on chromeless
 * mini-app routes (e.g. the phone capture page).
 */
function SiteChrome({ children }) {
  const { pathname } = useLocation();
  const chromeless = pathname.startsWith("/admin/ideas/capture");
  return (
    <>
      {!chromeless && <Navbar />}
      {children}
      {!chromeless && <Footer />}
    </>
  );
}

function NotFound() {
  return (
    <main
      className="mx-auto max-w-[1400px] px-6 lg:px-10 py-32"
      data-testid="not-found-page"
    >
      <div className="vbb-overline">
        <span className="vbb-dot" />
        404
      </div>
      <h1 className="font-display uppercase text-6xl sm:text-8xl mt-4 tracking-tighter pl-[0.35em]">
        <BoxedTitle size="lg" thick>
          Off
        </BoxedTitle>{" "}
        the grid.
      </h1>
      <p className="mt-6 max-w-xl text-[16px] leading-relaxed text-[#2a2a2a]">
        That page isn’t in the box. Head back to the{" "}
        <a href="/" className="vbb-link" data-testid="404-home-link">
          homepage
        </a>
        .
      </p>
    </main>
  );
}

export default function App() {
  return (
    <div className="App vbb">
      <BrowserRouter>
        <ScrollToTop />
        <SiteChrome>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/services" element={<Services />} />
            <Route path="/history" element={<History />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<AdminHome />} />
            <Route path="/admin/inbox" element={<AdminInbox />} />
            <Route path="/admin/market" element={<Market />} />
            <Route path="/admin/market/competitors" element={<Competitors />} />
            <Route
              path="/admin/market/competitors/:slug"
              element={<CompetitorDetail />}
            />
            <Route path="/admin/yc" element={<YCApplication />} />
            <Route path="/admin/essays" element={<AdminEssays />} />
            <Route path="/admin/essays/new" element={<AdminEssayEdit />} />
            <Route path="/admin/essays/:id" element={<AdminEssayEdit />} />
            <Route path="/admin/references" element={<AdminReferences />} />
            <Route
              path="/admin/references/new"
              element={<AdminReferenceEdit />}
            />
            <Route
              path="/admin/references/:id"
              element={<AdminReferenceEdit />}
            />
            <Route path="/admin/ideas" element={<AdminIdeas />} />
            <Route path="/admin/ideas/capture" element={<IdeaCapture />} />
            <Route path="/admin/ideas/new" element={<AdminIdeaEdit />} />
            <Route path="/admin/ideas/:id" element={<AdminIdeaEdit />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </SiteChrome>
      </BrowserRouter>
    </div>
  );
}
